import { TwoFactorResendResp } from 'types/api/response/two-factor-resend-resp'

import { api } from './api'

export const resendTwoFactorVerifierCode = (id: string) =>
  api.post<TwoFactorResendResp>(`/user_verifier/${id}/resend`)
